export function checkWindowSeStgValue(value) {
    if (value && value != 'false') {
        return true;
    }
    return false;
}
